import { useAuth0 } from '@auth0/auth0-react';
import { useAuthStore } from '@/store/use-auth-store';
import { useLoaderStore } from '@/store/use-loader-store';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useNavigation } from '../hooks/useNavigation';
import { isTeamsAuthPopupFlow } from '../utils/teams-auth';
import { shouldUseSoulMapConsumerLanding } from '@/utils/soulmap-auth';
import {
  isLoginRoute as isSsoLoginRoute,
  isPublicAuthFlowRoute,
  isTeamsSsoHandoff,
  isTeamsSsoInProgress,
  isTeamsSsoReloading,
} from '@/utils/sso-session-guard';

const PublicRoutes: React.FC = () => {
  const { navigateToHome } = useNavigation();
  const { isLoading } = useLoaderStore();
  const { isAuthenticated, tenants, showTenantSelector } = useAuthStore();
  const { isAuthenticated: isAuth0Authenticated } = useAuth0();
  const location = useLocation();

  useEffect(() => {
    const isTeamsAuthRoute = isTeamsAuthPopupFlow();
    const isSsoHandoffInProgress =
      isSsoLoginRoute(location.pathname) &&
      (isAuth0Authenticated ||
        isTeamsSsoInProgress() ||
        isTeamsSsoHandoff() ||
        isTeamsSsoReloading()) &&
      !isAuthenticated;

    const isSoulMapLoginRoute =
      location.pathname === '/soulmap-login' ||
      location.pathname.startsWith('/soulmap-login/');

    if (
      !isLoading &&
      isAuthenticated &&
      shouldUseSoulMapConsumerLanding() &&
      location.pathname === '/login'
    ) {
      navigateToHome({ replace: true });
      return;
    }

    if (
      !isLoading &&
      isAuthenticated &&
      tenants !== undefined &&
      !isPublicAuthFlowRoute(location.pathname) &&
      !isTeamsAuthRoute &&
      !isSoulMapLoginRoute &&
      !showTenantSelector &&
      !isSsoHandoffInProgress
    ) {
      navigateToHome({ replace: true });
    }
  }, [
    isLoading,
    isAuthenticated,
    tenants,
    location.pathname,
    showTenantSelector,
    isAuth0Authenticated,
  ]);

  return <Outlet />;
};

export default PublicRoutes;
